export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-480w.f75e8137.png";